import { render, staticRenderFns } from "./videoCardView.vue?vue&type=template&id=c0b4ad8e&scoped=true"
import script from "./videoCardView.vue?vue&type=script&lang=js"
export * from "./videoCardView.vue?vue&type=script&lang=js"
import style0 from "./videoCardView.vue?vue&type=style&index=0&id=c0b4ad8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4ad8e",
  null
  
)

export default component.exports